import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Gift, Cpu, Coins, Share2, X, ArrowRight } from "lucide-react";

const STEPS = [
  {
    icon: Gift,
    title: "Welcome to NIGAMAI 👋",
    body: "You've got 50 free credits to start building. Every message you send uses a few credits — no card needed.",
  },
  {
    icon: Cpu,
    title: "Pick your AI model",
    body: "Use the model picker at the top-left to switch between Gemini (1 credit), GPT-5.4 (2 credits) and Claude Sonnet (3 credits). Lighter models go further.",
  },
  {
    icon: Coins,
    title: "Track & top up credits",
    body: "Your balance is always in the top-right. Tap it anytime to buy more, or open Usage & History from the sidebar to see your spending.",
  },
  {
    icon: Share2,
    title: "Share what you build",
    body: "Hit the Share button in any chat to create a public read-only link — perfect for showing off your work.",
  },
];

export const OnboardingTour = ({ onClose }) => {
  const [step, setStep] = useState(0);
  const s = STEPS[step];
  const last = step === STEPS.length - 1;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="onboarding-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-2xl border border-white/10 bg-[#141415] overflow-hidden nig-glow-border animate-fade-in-up">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-64 h-40 blur-[80px] opacity-30" style={{ background: "radial-gradient(circle, #00FF66 0%, transparent 70%)" }} />
        <button
          data-testid="onboarding-skip"
          onClick={onClose}
          className="absolute top-4 right-4 text-zinc-500 hover:text-white transition-colors z-10"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="relative p-8 text-center">
          <div className="w-16 h-16 rounded-2xl bg-[#00FF66] flex items-center justify-center mx-auto mb-6 shadow-[0_0_40px_rgba(0,255,102,0.4)]">
            <s.icon className="w-8 h-8 text-black" />
          </div>
          <h2 className="font-heading font-bold text-2xl tracking-tighter text-white">{s.title}</h2>
          <p className="text-zinc-400 mt-3 leading-relaxed">{s.body}</p>

          <div className="flex items-center justify-center gap-2 mt-8">
            {STEPS.map((_, i) => (
              <span
                key={i}
                className={`h-1.5 rounded-full transition-all duration-300 ${i === step ? "w-6 bg-[#00FF66]" : "w-1.5 bg-white/15"}`}
              />
            ))}
          </div>

          <div className="flex gap-3 mt-8">
            {step > 0 && (
              <Button
                onClick={() => setStep(step - 1)}
                variant="outline"
                className="flex-1 h-11 bg-transparent border-white/15 hover:bg-[#1F1F22] text-white rounded-lg transition-colors"
              >
                Back
              </Button>
            )}
            <Button
              data-testid={last ? "onboarding-finish" : "onboarding-next"}
              onClick={() => (last ? onClose() : setStep(step + 1))}
              className="flex-1 h-11 bg-[#00FF66] hover:bg-[#00CC52] text-black font-semibold rounded-lg transition-colors group"
            >
              {last ? "Start building" : "Next"}
              <ArrowRight className="w-4 h-4 ml-1.5 group-hover:translate-x-0.5 transition-transform" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
